interface LabelRequiredProps {
    label: string;
    isRequired: boolean;
}

function LabelRequired(props: LabelRequiredProps) {
    const { label, isRequired } = props;
    return (
        <>
            {label}
            {isRequired && (
                <span style={{ color: "red", marginLeft: 4 }}>
                    *
                </span>
            )}
        </>
    );
}

export default LabelRequired;